import script from "./ProcessosAberturaForm_24.vue?vue&type=script&setup=true&lang=js"
export * from "./ProcessosAberturaForm_24.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__